export function IncrementFolderCounter(jobId, folderId, cameraId, userGroup, types, options) {
  options = options || {};
  let ref = options.ref || FirebaseWorker.ref();
  let timestamp = options.timestamp || firebase.database.ServerValue.TIMESTAMP;
  // Make sure types is an array
  if (!Array.isArray(types)) types = [types];
  // Get folder data.
  ref.child('photoheight/jobs/' + jobId + '/photo_folders/' + folderId).once('value', (s) => {
    let folder = s.val();
    if (!folder) return;
    // console.trace('transaction', 'photoheight/jobs/' + jobId + '/photo_folders/' + folderId, cameraId)
    s.ref.child('cameras/' + cameraId).transaction(
      (camera) => {
        if (camera) {
          types.forEach((type) => {
            incrementCount(jobId, folderId, folder, cameraId, camera, userGroup, type, options);
          });
        }
        return camera;
      },
      (error, committed) => {
        if (error) console.warn('Error Updating Camera Count', error, committed);
      }
    );
    // Increment counters on job summary.
    types.forEach((type) => {
      if (validTypes.indexOf(type) != -1) {
        ref
          .child('photoheight/jobs/' + jobId + '/sharing')
          .once('value')
          .then((s) => {
            for (let companyId in s.val())
              ref.child(`photoheight/counters/${companyId}/${jobId}/${type}`).transaction(
                (counter) => {
                  counter = counter || { value: 0 };
                  counter.value += (options.negative ? -1 : 1) * (options.count || 1);
                  // TODO: Add logic to limit max number of photos.
                  // if (type !== 'numPhotos' && counter.value > folder.numPhotos) counter.value = folder.numPhotos;
                  counter.last_modified = timestamp;
                  return counter;
                },
                (error, committed) => {
                  if (error) console.warn('Error Job Permissions Count', error, committed);
                }
              );
          });
        // Update on photoFolder, too.
        ref.child('photoheight/jobs/' + jobId + '/photo_folders/' + folderId + '/' + type).transaction(
          (counter) => {
            counter += (options.negative ? -1 : 1) * (options.count || 1);
            if (type !== 'numPhotos' && counter > folder.numPhotos) counter = folder.numPhotos;
            return counter;
          },
          (error, committed) => {
            if (error) console.warn('Error Updating Folder Count', error, committed);
          }
        );
      } else {
        console.warn('Invalid type given', type);
      }
    });
  });
}
let validTypes = ['numPhotos', 'numUploaded', 'numTagged', 'numAssociated'];
var changeStatusWhenComplete = {
  numUploaded: 'Tagging',
  numTagged: 'Associating',
  numAssociated: 'Complete'
};
var incrementCount = function (jobId, folderId, folder, cameraId, camera, userGroup, type, options) {
  let ref = options.ref || FirebaseWorker.ref();
  // Increment camera's counter.
  camera[type] = (camera[type] || 0) + (options.negative ? -1 : 1) * (options.count || 1);
  if (type !== 'numPhotos' && camera[type] > folder.numPhotos) camera[type] = folder.numPhotos;
  // Calc how many of the given type have been completed.
  let numPhotos = 0;
  let numCompleted = 0;
  for (let id in folder.cameras) {
    numPhotos += folder.cameras[id].numPhotos || 0;
    numCompleted += (id == cameraId ? camera[type] : folder.cameras[id][type]) || 0;
  }
  // Set status if fully complete.
  if (numPhotos > 0 && numPhotos == numCompleted && changeStatusWhenComplete[type]) {
    var update = {};
    var status = changeStatusWhenComplete[type];
    if (options.completeWhenDone) {
      status = 'Complete';
    }
    if (userGroup != null) {
      update['company_space/' + userGroup + '/photo_folders/' + folderId + '/status'] = status;
    }
    update['jobs/' + jobId + '/photo_folders/' + folderId + '/status'] = status;
    ref.child('photoheight').update(update, (err) => {
      if (err) console.warn(err);
    });
  }
};
